export default __webpack_public_path__ + "static/media/28.e804f238.jpeg";